<template>
  <section class="section-connection-lost">
    <div class="text-center">
      <img
        alt="Connection Lost"
        height="75"
        src="@/assets/img/icons/connection-lost.svg"
        width="75"
      />

      <h6 class="mb-1">Oops!</h6>
      <h6 class="mb-5">Connection Lost</h6>
      <div class="proceed-btn">
        <button
          class="btn py-md-2 px-md-3"
          type="button"
          @click="retry"
        >
          Retry
        </button>
      </div>
    </div>
  </section>
</template>

<script>
export default {
  name: "ConnectionLost",
  methods: {
    retry() {
      window.location.reload()
    },
  }
}
</script>

<style>
.section-connection-lost {
  width: 100%;
  height: 100vh;

  display: flex;

  align-items: center;
  justify-content: center;
}

.proceed-btn button {
  border-radius: 5px;
  font-size: 14px;
  height: 50px;
  text-align: center;
  color: #fff !important;
  border: 2px solid transparent;
  font-weight: bold;
  background: linear-gradient(179.89deg, #3876d2 0.72%, #3876d2 216.45%);
}
</style>



// WEBPACK FOOTER //
// src/components/Partials/connection-lost.vue